<div id="authenticated-payment-method" class="authenticated-payment-method d-flex flex-column">
    <div class="d-flex flex-row align-items-center">
        @if (!!paymentMethodSelected) {
            <div class="d-flex flex-grow-1">
                <app-payment-method-selected
                    [aboveThreshold]="aboveThreshold"
                    [width]="paymentMethodSelected === PaymentMethods.ECHECK ? '45px' : '80px'"
                />
            </div>
        } @else {
            <mat-icon color="accent" class="material-symbols-outlined md-icon-24"> error_outlined </mat-icon>
            <div class="ms-2 no-payment-title mat-caption d-flex flex-grow-1">Select your payment method.</div>
        }
    </div>

    @if (showError) {
        <div class="ms-2 payment-method-error">{{ msgError }}</div>
    }
</div>
